import { Spinner } from '@chakra-ui/react';
import { useState } from 'react';
import { PageContainer } from '../../components/Layout/PageContainer';
import { PageBreadcrumb } from '../../components/UI/PageBreadcrumb';
import { SearchInput } from '../../components/UI/SearchInput';
import { ProgramsTable } from '../../components/Tables/ProgramsTable';
import ProgramEditDialog from '../../components/ProgramEditDialog';
import { useProgramsQuery } from '../../query/useProgramsQuery';

export function ProgramsPage() {
	const { data, isLoading } = useProgramsQuery();
	const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
	const [selectedProgram, setSelectedProgram] = useState<any>(null);

	const handleEdit = (row: any) => {
		console.log('Edit clicked for program:', row);
		setSelectedProgram(row);
		setIsEditDialogOpen(true);
	};

	const handleAdd = () => {
		console.log('Add new program clicked');
		setSelectedProgram(null); // No program data for new program
		setIsEditDialogOpen(true);
	};

	const handleDialogClose = (open: boolean) => {
		setIsEditDialogOpen(open);
		if (!open) {
			setSelectedProgram(null);
		}
	};

	return (
		<PageContainer>
			<PageBreadcrumb items={['Home', 'Programs']} />
			<SearchInput placeholder="Search by Program Name" />
			{isLoading ? <Spinner size="xl" mt="40px" color="teal.500" /> :
				<ProgramsTable data={data ?? []} onEdit={handleEdit} onAdd={handleAdd} />
			}
			<ProgramEditDialog
				open={isEditDialogOpen}
				onOpenChange={handleDialogClose}
				programData={selectedProgram}
			/>
		</PageContainer>
	);
}